import { useTexture } from '@react-three/drei'

export default function Mug(props)
{
    // Programming Languages with professional textures
    const cppMugTexture = useTexture('./Textures/cpp-skill.jpg')
    const javaMugTexture = useTexture('./Textures/java-skill.jpg')
    const pythonMugTexture = useTexture('./Textures/python-skill.jpg')
    const cMugTexture = useTexture('./Textures/c-skill.jpg')


    return <>
      {/* C++ Mug */}
      <mesh
        geometry={props.nodes.ReactMug.geometry}
        position={[0, 1, 0]}
      >
        <meshBasicMaterial map={cppMugTexture} map-flipY={false} />
      </mesh>

      {/* Java Mug */}
      <mesh
        geometry={props.nodes.ThreeJSMug.geometry}
        position={[0, 1, 0]}
      >
        <meshBasicMaterial map={javaMugTexture} map-flipY={false} />

      </mesh>

      {/* Python Mug */}
      <mesh        
        geometry={props.nodes.SymfonyMug.geometry}
        position={[0, 1, 0]}
      >
        <meshBasicMaterial map={pythonMugTexture} map-flipY={false} />

      </mesh>
      
      {/* C Mug */}
      <mesh    
        geometry={props.nodes.BlenderMug.geometry}
        position={[0, 1, 0]}
      >
        <meshBasicMaterial map={cMugTexture} map-flipY={false} />

      </mesh>
    </>
}